import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { trackFooter as track } from "~/events";
import { Facebook, Instagram, LinkedIn, Medium, Twitter } from "~/icons";
import { Chunk } from "./Chunk";
import { SocialIcon } from "./SocialIcon";

const text = {
  socialIntro: "Better Together",
  socialHeading: "Let's connect",
};

export const SocialMediaChunk: FC = () => {
  return (
    <Chunk smHeading={text.socialIntro} lgHeading={text.socialHeading}>
      <Flex
        align="center"
        justify={{ base: "center", md: "space-between" }}
        wrap="wrap"
        mt={{ base: "0", md: 4 }}
        w="100%"
      >
        <SocialIcon
          Icon={Facebook}
          aria-label="Facebook Link"
          href="https://www.facebook.com/weconceive"
          onClick={track.facebookLink}
        />
        <SocialIcon
          Icon={Twitter}
          aria-label="Twitter Link"
          href="https://twitter.com/conceive"
          onClick={track.twitterLink}
        />
        <SocialIcon
          Icon={Instagram}
          aria-label="Instagram Link"
          href="https://www.instagram.com/weconceive/"
          onClick={track.instagramLink}
        />
        <SocialIcon
          Icon={LinkedIn}
          aria-label="LinkedIn Link"
          href="https://www.linkedin.com/company/weconceive/"
          onClick={track.linkedInLink}
        />
        <SocialIcon
          Icon={Medium}
          aria-label="Medium Link"
          href="https://medium.com/@weconceive"
          onClick={track.mediumLink}
          viewBox="0 0 54 28"
        />
      </Flex>
    </Chunk>
  );
};
